import type { Utente } from '@framework/api-client';
import dayjs from 'dayjs';
import type { ISessionData } from './ISessionData';
import {
  mergeLegalEntitySessionData,
  toLegalEntitySessionData,
} from './legalEntitySessionData';

/**
 * Nel validatore sono tutte prefissate da `session`,
 * es. `session.richiedente.nome`
 */
export function getSessionValidationContext(
  user: Utente | null | undefined,
): ISessionData {
  const dataNascita = user?.datiAnagraficiAggiuntivi?.dataNascita;
  const dataRilascioCi =
    user?.datiAnagraficiAggiuntivi?.cartaIdentita?.dataRilascio;
  const dataScadenzaCi =
    user?.datiAnagraficiAggiuntivi?.cartaIdentita?.dataScadenza;
  const selectedProfileLegalEntity = user?.profiloSelezionato?.personaGiuridica;
  const spidLegalEntity = user?.datiAnagraficiAggiuntivi?.personaGiuridica;
  const selectedProfileLegalEntityData = toLegalEntitySessionData(
    selectedProfileLegalEntity,
  );
  const spidLegalEntityData = toLegalEntitySessionData(spidLegalEntity);
  const mergedLegalEntity = mergeLegalEntitySessionData(
    spidLegalEntityData,
    selectedProfileLegalEntityData,
  );

  return {
    data_compilazione: dayjs().format('YYYY-MM-DD[T]HH:mm:ss'),
    richiedente: {
      nome: user?.nome,
      cognome: user?.cognome,
      email: user?.email,
      codiceFiscale: user?.codiceFiscale,
      codice_fiscale: user?.codiceFiscale,
    },
    datiAnagraficiAggiuntivi: {
      capDomicilioFisico: user?.datiAnagraficiAggiuntivi?.capDomicilioFisico,
      partitaIva: user?.datiAnagraficiAggiuntivi?.codiceIva,
      comuneDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.comuneDomicilioFisico,
      dataNascita:
        dataNascita && dayjs(dataNascita, 'YYYY-MM-DD').isValid()
          ? dayjs(dataNascita).format('YYYY-MM-DD')
          : undefined,
      genere: user?.datiAnagraficiAggiuntivi?.genere,
      indirizzo: user?.datiAnagraficiAggiuntivi?.indirizzo,
      indirizzoDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.indirizzoDomicilioFisico,
      indirizzoDigitale: user?.datiAnagraficiAggiuntivi?.indirizzoDigitale,
      nazioneDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.nazioneDomicilioFisico,
      numeroCellulare: user?.datiAnagraficiAggiuntivi?.numeroCellulare,
      paeseDiNascita: null, // Non disponibile
      provinciaDomicilioFisico:
        user?.datiAnagraficiAggiuntivi?.provinciaDomicilioFisico,
      sedeLegale: user?.datiAnagraficiAggiuntivi?.sedeLegale,
      tipologiaCi: user?.datiAnagraficiAggiuntivi?.cartaIdentita?.tipologia,
      idCi: user?.datiAnagraficiAggiuntivi?.cartaIdentita?.id,
      comuneRilascioCi:
        user?.datiAnagraficiAggiuntivi?.cartaIdentita?.comuneRilascio,
      dataRilascioCi:
        dataRilascioCi && dayjs(dataRilascioCi, 'YYYY-MM-DD').isValid()
          ? dayjs(dataRilascioCi).format('YYYY-MM-DD')
          : undefined,
      dataScadenzaCi:
        dataScadenzaCi && dayjs(dataScadenzaCi, 'YYYY-MM-DD').isValid()
          ? dayjs(dataScadenzaCi).format('YYYY-MM-DD')
          : undefined,
      denominazioneLuogoNascita:
        user?.datiAnagraficiAggiuntivi?.luogoDiNascita?.denominazione,
      codiceLuogoNascita:
        user?.datiAnagraficiAggiuntivi?.luogoDiNascita?.codice,
      denominazioneProvinciaNascita:
        user?.datiAnagraficiAggiuntivi?.provinciaDiNascita?.denominazione,
      codiceProvinciaNascita:
        user?.datiAnagraficiAggiuntivi?.provinciaDiNascita?.codice,
      metodoLoginUtilizzato:
        user?.datiAnagraficiAggiuntivi?.metodoLoginUtilizzato,
    },
    selectedProfileType: user?.profiloSelezionato?.tipo,
    selectedProfileLegalEntity: selectedProfileLegalEntityData,
    spidLegalEntity: spidLegalEntityData,
    mergedLegalEntity,
  };
}
